/**
 * Hujjah Analytics — thin wrapper over PostHog.
 * Gracefully no-ops when REACT_APP_POSTHOG_KEY is absent.
 */

let _posthog = null;

const POSTHOG_KEY  = process.env.REACT_APP_POSTHOG_KEY  || "";
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || "https://app.posthog.com";

export function initAnalytics() {
  if (!POSTHOG_KEY) return;
  import("posthog-js").then(({ default: posthog }) => {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      autocapture: false,
      capture_pageview: false,
      persistence: "localStorage",
    });
    _posthog = posthog;
  }).catch(() => {});
}

export function identifyUser(userId, traits = {}) {
  if (!_posthog) return;
  _posthog.identify(String(userId), traits);
}

export function trackEvent(event, properties = {}) {
  if (!_posthog) return;
  _posthog.capture(event, properties);
}

export function resetAnalyticsUser() {
  if (!_posthog) return;
  _posthog.reset();
}
